import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function SortingConfiguration({ formData, handleInputChange }) {
  const { t } = useTranslation();
  const sortFieldOptions = useMemo(() => {
    const localFields = (formData.fields || []).map((field) => field.name).filter(Boolean);
    return Array.from(new Set(['created', formData.sortField, ...localFields].filter(Boolean)));
  }, [formData.fields, formData.sortField]);

  return (
    <>
      <h3 className="text-sm font-medium text-gray-900 mb-3">{t('customCollections.form.sorting.title')}</h3>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">{t('customCollections.form.sorting.sortField')}</label>
          <select
            name="sortField"
            value={formData.sortField || ''}
            onChange={handleInputChange}
            className="w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
          >
            {sortFieldOptions.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">{t('customCollections.form.sorting.sortDirection')}</label>
          <select
            name="sortDirection"
            value={formData.sortDirection || 'desc'}
            onChange={handleInputChange}
            className="w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600"
          >
            <option value="asc">{t('customCollections.list.sortDirections.asc')}</option>
            <option value="desc">{t('customCollections.list.sortDirections.desc')}</option>
          </select>
        </div>
      </div>
      <p className="mt-3 text-[11px] text-gray-500">{t('customCollections.form.sorting.hint')}</p>
    </>
  );
}
